import { ArrowRight } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_women-economy/artifacts/p7si2gi8_shescan%20logo%20mark%20and%20nameOrangeFinal.png";

/**
 * 404 — rendered by the catch-all route. Kept intentionally sparse
 * so it feels like part of the site, not a scary error page.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen bg-paper text-ink font-sans flex items-center justify-center px-5">
      <div
        data-testid="not-found"
        className="w-full max-w-[520px] text-center space-y-8"
      >
        <img
          src={LOGO}
          alt="SheScan"
          className="h-10 sm:h-12 w-auto mx-auto"
          data-testid="not-found-logo"
        />
        <div className="space-y-4">
          <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-brand-orange block">
            404 · Page not found
          </span>
          <h1
            data-testid="not-found-title"
            className="font-display font-bold tracking-tight text-ink text-3xl sm:text-4xl leading-[1.1]"
          >
            This isn&apos;t a page on SheScan.
          </h1>
        </div>
        <a
          href="/"
          data-testid="not-found-home-link"
          className="group inline-flex items-center justify-center gap-3 border-2 border-brand-orange bg-brand-orange text-white font-sans font-bold uppercase text-xs tracking-[0.22em] px-6 py-4 hover:bg-white hover:text-ink hover:border-line transition-colors"
        >
          Go home
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </div>
  );
}
